import * as Yup from 'yup'

const editServiceValidator = Yup.object ({
  id: Yup.string (),
  nickname: Yup.string (),
  cutilei_service: Yup.boolean (),
  description: Yup.string ().max (128, 'A descrição deve ter no máximo 128 caracteres'),
  duration: Yup.number (),
  max_delay: Yup.number (),
  price: Yup.number ().positive ('Insira o preço'),
  comission_percentage: Yup.number ().when ('cutilei_service', {
    is: true,
    then: Yup.number ().positive ('Insira a comissão')
  }),
  professional_comission: Yup.number (),
  business_comission: Yup.number (),
  products: Yup.array ().of (Yup.object ().shape ({
    id: Yup.string ().required ('Selecione o produto'),
    name: Yup.string ().required ('Selecione o produto'),
    quantity_used: Yup.number ()
  }))
})

export default editServiceValidator
